import { render, staticRenderFns } from "./SpeakersBlockList.vue?vue&type=template&id=425b6ca6"
import script from "./SpeakersBlockList.vue?vue&type=script&lang=ts"
export * from "./SpeakersBlockList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports